<template>
    <card-seplag titulo="Habilidade/Experiência Profissional" class="p-col-12">
        <div class="p-col-12 avisos">
            <ul>
                <li>
                    <p><strong>Servidor, inclua as habilidades e experiências referentes aos idiomas, sistemas corporativos e atividades que você desempenhou ao longo da sua carreira profissional.</strong></p>
                </li>
            </ul>
        </div>
       
        <Rotulo nome="" class="p-col-12">
        </Rotulo>
        <card-seplag titulo="Habilidades/Experiências profissionais cadastradas" class="p-col-12 ajusteSecao">
            <div class="p-col-12 ajusteSecao">
            <div class="p-col-12 ajustePanel" v-if="experienciasAtivas && experienciasAtivas.length > 0">
                <button  v-for="(experiencia, index) in experienciasAtivas" :key="experiencia.idenExperienciaCicloPessoa" type="button" @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
                <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel"  >
                    <template slot="header">
                        <span class="acordion">{{colapseTeste}}</span>
                        <span>{{index + 1 + ' - ' + experiencia.experiencia.descExperiencia }}</span>
                        <span class="acordion">{{isCollapsed}}</span>
                    </template>
                    <div class="p-grid p-fluid ">
                        <div class="p-col-12 ajusteContent">
                            <label><strong>Subatividade/experiência em:
                                </strong>{{ experiencia.subExperiencia.descExperiencia }}</label>
                        </div>
                        <div class="p-col-12 ajusteContent">
                            <label><strong>Escala de habilidade: </strong>
                                {{ experiencia.escalaExperiencia.descExperiencia }}</label>
                        </div>
                        <div class="p-col-12 ajusteContent"
                            v-if="experiencia.experiencia.descExperiencia == 'OUTRA' || experiencia.experiencia.descExperiencia == 'ATIVIDADE/FUNÇÃO'">
                            <label><strong>Descrição da habilidades: </strong>
                                {{ experiencia.descExperienciaCicloPessoa }}</label>
                        </div>
                        
                    </div>
                </Panel>
                </button>
            </div>
            <span v-else><i>Nenhum registro encontrado</i></span>
           
        </div>
        </card-seplag>

        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12 p-md-2 p-md-offset-3">
                    <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
                </div>
               
                <div class="p-col-12 p-md-2">
                    <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </div>
        </div>
    </card-seplag>

</template>

<script>

import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { simNao } from '@/config/global'
import { baseApiUrl } from '@/config/global'


const getDefaultState = () => {
    return {
        idenExperienciaCicloPessoa: null,
        experiencia: null,
        subExperiencia: null,
        escalaExperiencia: null,
        descExperienciaCicloPessoa: '',
        status: 'ATIVO'
    }
}

export default {
    name: "experiencia-profissional",
    components: { CardSeplag, Rotulo, },
    data: function () {
        return {
            tiposExperiencia: [
                { codgTipoExperiencia: 1, descTipoExperiencia: 'Serviço Público no Estado de Mato Grosso' },
                { codgTipoExperiencia: 2, descTipoExperiencia: 'Fora do Serviço Público no Estado de Mato Grosso' }
            ],
            simNao: simNao,
            areasConhecimento: [],
            orgaos: [],
            setores: [],
            experienciasServPublico: [],
            experienciasForaServPublico: [],
            colunasExperienciasForaServPublico: [

                { nome: 'nomeEmpresaOrgao', titulo: 'Empresa' },
                { nome: 'tempo', titulo: 'Tempo' },
                { nome: 'areaConhecimento.descAreaConhecimento', titulo: 'Área de Conhecimento' },
                { nome: 'descExperienciaForaMt', titulo: 'Experiência' }
            ],
            dadosPessoa: this.$store.getters.getDadosPessoa,
            registro: getDefaultState(),
            flagEditar: false,
            totalCaracter: 500,
            controleAccord: [],
            experiencias: null,
            experienciaAux: null,
            subExperiencias: null,
            nivelExperiencia: null,
            periodoExperiencia: null,
            experienciasAtivas: [],
            nomeExperiencia: null,
            exp: {
                cicloPessoa: {
                    idenCicloPessoa: this.$store.getters.getCicloPessoa[0].idenCicloPessoa,
                },
                experiencia: null,
                subExperiencia: null,
                escalaExperiencia: null,
                descExperienciaCicloPessoa: '',
                status: 'ATIVO'
            },
            idenExperienciaCicloPessoa: null,
            isCollapsed:false,
            colapseTeste:[],
            controlePanel:[],
            exibirNovaExperiencia: false
        }
    },
    methods: {
        carregarDados() {
            //listar experiencias
            this.$http.get(`${baseApiUrl}/experienciaprof/experiencias`).then(res => {
                this.experiencias = res.data
            })
            //listar experiencias ativas 
            this.$http.get(`${baseApiUrl}/experienciaprofcp/ciclopessoa/${this.exp.cicloPessoa.idenCicloPessoa}`).then(res => {
                this.experienciasAtivas = res.data
                for (let i = 0; i < this.experienciasAtivas.length; i++) {
                    this.controlePanel[i] = true
                    this.colapseTeste[i] = false
                }
            })

        },
        
        fechaTodosAccord() {
            for (let i = 0; i < this.experienciasAtivas.length; i++) {
                this.controlePanel[i] = false
            }

        },
        nextPage() {
            this.$router.push({ name: 'RECADVIEW_DEPENDENTES_VIEW' })
        },
        prevPage() {
            this.$router.push({ name: 'RECADVIEW_CAPACITACAO_VIEW' })
        },
        funcaoAccord(index) {
            this.controlePanel[index] = this.isCollapsed
            this.isCollapsed = !this.isCollapsed 
            this.controlePanel[index] =  this.colapseTeste[index] 
            this.colapseTeste[index] = !this.colapseTeste[index]
        },

    },
    mounted() {
        this.carregarDados()
    }
}
</script>
<style scoped>
.ajusteSecao{
    margin-top: 20px;
}
.ajustaBotao {
    /* justify-items: ; */
    justify-content: space-between;
    margin-top: 20px;
}
.ajustePanel{
    margin-top:-15px;
}
.ajusteContent{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start !important;
    justify-items: flex-start;
    margin-right: 1500px;
}
.acordion{
    display: none;
}
</style>
